import _defineProperty2 from "/data/buildAgent/sid-teamcity-agent-01/work/7ee7b29b3220b2e5/portals/UPGRADE/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import { intlMessageShape, tooltipBaseProps, deprecated, placementOptions } from '@jutro/prop-types';
import { ContextConsumer, getMessageProp } from '@jutro/platform';
import { TooltipContent } from './TooltipContent';
import styles from "./TooltipIcon.module.css";
import { Tooltip } from './Tooltip';
import { Icon } from '../Icon/Icon';
import { messages } from './TooltipIcon.messages';
export var TooltipIcon = function (_React$Component) {
  _inherits(TooltipIcon, _React$Component);
  var _super = _createSuper(TooltipIcon);
  function TooltipIcon(props) {
    var _this;
    _classCallCheck(this, TooltipIcon);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      if (_this.iconRef && _this.tooltip && !_this.tooltip.popper.contains(event.target) && !_this.iconRef.current.contains(event.target)) {
        _this.hideTooltip();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getOpenIcon", function (icon) {
      return "".concat(icon);
    });
    _defineProperty(_assertThisInitialized(_this), "getClosedIcon", function (icon) {
      return "".concat(icon, "-outline");
    });
    _defineProperty(_assertThisInitialized(_this), "setClosedIcon", function _callee() {
      return _regeneratorRuntime().async(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _this.setState({
              icon: _this.getClosedIcon(_this.props.icon)
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, null, null, null, Promise);
    });
    _defineProperty(_assertThisInitialized(_this), "setOpenIcon", function _callee2() {
      return _regeneratorRuntime().async(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this.setState({
              icon: _this.getOpenIcon(_this.props.icon)
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, null, null, null, Promise);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleTooltip", function (evt) {
      evt.preventDefault();
      var _assertThisInitialize = _assertThisInitialized(_this),
        tooltip = _assertThisInitialize.tooltip,
        setClosedIcon = _assertThisInitialize.setClosedIcon,
        setOpenIcon = _assertThisInitialize.setOpenIcon;
      if (tooltip) {
        if (tooltip.state.isVisible) {
          setClosedIcon().then(tooltip.hide);
        } else {
          setOpenIcon().then(tooltip.show);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hideTooltip", function () {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
        tooltip = _assertThisInitialize2.tooltip,
        setClosedIcon = _assertThisInitialize2.setClosedIcon;
      if (tooltip !== null && tooltip !== void 0 && tooltip.state.isVisible) {
        setClosedIcon().then(tooltip.hide);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getAccessibilityProperties", function (translator) {
      var messageProps = _this.props.messageProps;
      var showTooltipLabel = getMessageProp('showTooltip', messageProps, messages);
      return {
        'aria-label': translator(showTooltipLabel),
        'aria-haspopup': 'true'
      };
    });
    _defineProperty(_assertThisInitialized(_this), "renderComponent", function (translator) {
      var _this$props = _this.props,
        id = _this$props.id,
        text = _this$props.text,
        title = _this$props.title,
        link = _this$props.link,
        href = _this$props.href,
        renderContent = _this$props.renderContent,
        className = _this$props.className,
        placementProp = _this$props.placement,
        tipPlacement = _this$props.tipPlacement,
        flipBehavior = _this$props.flipBehavior,
        labelPosition = _this$props.labelPosition,
        showInlineLabel = _this$props.showInlineLabel;
      var placement = tipPlacement || placementProp;
      var icon = _this.state.icon;
      var content = renderContent ? renderContent() : React.createElement(TooltipContent, {
        title: title,
        text: text,
        href: href,
        link: link,
        translator: translator
      });
      var tooltipProps = {
        id: id,
        content: content,
        placement: placement,
        trigger: 'manual',
        hideOnClick: false,
        flipBehavior: flipBehavior
      };
      var classes = cx(styles.tooltipIcon, _defineProperty2({}, styles[labelPosition], !showInlineLabel), className);
      return React.createElement(Tooltip, _extends({}, tooltipProps, {
        onCreate: function onCreate(tooltip) {
          _this.tooltip = tooltip;
        }
      }), React.createElement("button", _extends({
        ref: _this.iconRef,
        type: "button",
        onClick: _this.toggleTooltip,
        className: classes
      }, _this.getAccessibilityProperties(translator)), React.createElement(Icon, {
        icon: icon,
        "aria-hidden": "true"
      })));
    });
    _this.state = {
      icon: _this.getClosedIcon(props.icon)
    };
    _this.iconRef = React.createRef();
    return _this;
  }
  _createClass(TooltipIcon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(ContextConsumer, {
        contexts: [TranslatorContext]
      }, this.renderComponent);
    }
  }]);
  return TooltipIcon;
}(React.Component);
_defineProperty(TooltipIcon, "propTypes", _objectSpread({
  id: PropTypes.string.isRequired,
  icon: PropTypes.string
}, tooltipBaseProps, {
  tipPlacement: deprecated(PropTypes.string, '6.0.0', 'Use placement instead.'),
  placement: PropTypes.oneOf(placementOptions),
  className: PropTypes.string,
  messageProps: PropTypes.shape({
    showTooltip: intlMessageShape
  }),
  flipBehavior: PropTypes.array,
  labelPosition: PropTypes.oneOf(['top', 'left']),
  showInlineLabel: PropTypes.bool
}));
_defineProperty(TooltipIcon, "defaultProps", {
  icon: 'mi-help'
});
TooltipIcon.__docgenInfo = {
  componentName: "TooltipIcon",
  packageName: "@jutro/components",
  description: "",
  displayName: "TooltipIcon",
  methods: [{
    name: "handleClickOutside",
    docblock: "Handles clicking outside\n@param {Event} event",
    modifiers: [],
    params: [{
      name: "event",
      description: null,
      type: {
        name: "Event"
      },
      optional: false
    }],
    returns: null,
    description: "Handles clicking outside"
  }, {
    name: "getOpenIcon",
    docblock: "getOpenIcon\n@param {string} icon\n@returns {string}",
    modifiers: [],
    params: [{
      name: "icon",
      description: null,
      type: {
        name: "string"
      },
      optional: false
    }],
    returns: {
      description: null,
      type: {
        name: "string"
      }
    },
    description: "getOpenIcon"
  }, {
    name: "getClosedIcon",
    docblock: "getClosedIcon\n@param {string} icon\n@returns {string}",
    modifiers: [],
    params: [{
      name: "icon",
      description: null,
      type: {
        name: "string"
      },
      optional: false
    }],
    returns: {
      description: null,
      type: {
        name: "string"
      }
    },
    description: "getClosedIcon"
  }, {
    name: "setClosedIcon",
    docblock: null,
    modifiers: ["async"],
    params: [],
    returns: null
  }, {
    name: "setOpenIcon",
    docblock: null,
    modifiers: ["async"],
    params: [],
    returns: null
  }, {
    name: "toggleTooltip",
    docblock: "toggleTooltip\n@param {Event} evt",
    modifiers: [],
    params: [{
      name: "evt",
      description: null,
      type: {
        name: "Event"
      },
      optional: false
    }],
    returns: null,
    description: "toggleTooltip"
  }, {
    name: "hideTooltip",
    docblock: null,
    modifiers: [],
    params: [],
    returns: null
  }, {
    name: "getAccessibilityProperties",
    docblock: "Returns accessibility properties for tooltip icon button\n\n@param {Function} translator function used to translate the message\n@returns {object} object containing accessibility properties",
    modifiers: [],
    params: [{
      name: "translator",
      description: "function used to translate the message",
      type: {
        name: "Function"
      },
      optional: false
    }],
    returns: {
      description: "object containing accessibility properties",
      type: {
        name: "object"
      }
    },
    description: "Returns accessibility properties for tooltip icon button"
  }, {
    name: "renderComponent",
    docblock: "Render tooltip icon\n\n@param {Function} translator function to translate strings\n@returns {React.ReactElement} tooltip icon",
    modifiers: [],
    params: [{
      name: "translator",
      description: "function to translate strings",
      type: {
        name: "Function"
      },
      optional: false
    }],
    returns: {
      description: "tooltip icon",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Render tooltip icon"
  }],
  actualName: "TooltipIcon",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify the component. Referenced to find it in the document tree"
    },
    icon: {
      type: {
        name: "string"
      },
      required: false,
      description: "Icon to be displayed",
      defaultValue: {
        value: "'mi-help'",
        computed: false
      }
    },
    tipPlacement: {
      type: {
        name: "string"
      },
      required: false,
      description: "@deprecated Position of the tooltip in relation to icon",
      deprecationInfo: {
        version: "6.0.0",
        mapTo: null
      }
    },
    placement: {
      type: {
        name: "enum",
        computed: true,
        value: "placementOptions"
      },
      required: false,
      description: "Positions of the tooltip relative to its reference element (icon)"
    },
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "Additional class names for component."
    },
    messageProps: {
      type: {
        name: "shape",
        value: {
          showTooltip: {
            name: "union",
            required: false,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: false
                },
                defaultMessage: {
                  name: "string",
                  required: false
                },
                args: {
                  name: "shape",
                  value: {},
                  required: false
                }
              }
            }]
          }
        }
      },
      required: false,
      description: "Message props(error message/aria-label)"
    },
    flipBehavior: {
      type: {
        name: "array"
      },
      required: false,
      description: "Determines the order of flipping of tooltip, i.e. which placements to prefer if a certain placement cannot be used"
    },
    labelPosition: {
      type: {
        name: "enum",
        value: [{
          value: "'top'",
          computed: false
        }, {
          value: "'left'",
          computed: false
        }]
      },
      required: false,
      description: "Information from Field Component to the Tooltip Icon about the whole label position"
    },
    showInlineLabel: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Information from Field Component. If true, label is displayed inline"
    }
  },
  composes: ["@jutro/prop-types"]
};